/** @jsx jsx */
import { Component } from 'react';
import { jsx, css } from '@emotion/core'
import { Link } from 'react-router-dom'

import { default_theme as theme } from '../emotion/theme'

class DefaultIconButton extends Component {
    renderButton = () => {
        const {
            extra_class,
            onClickButton,
            disabled,
            type,
            icon_src,
            icon_height,
        } = this.props;
        
        return(
            <button
                css={ [main, btn, extra_class] }
                disabled={disabled}
                onClick={!disabled ? onClickButton : function() {}} 
                type={type}>         
              {icon_src &&
               <img src={icon_src} alt="" css={ [icon, css`height:${icon_height};`] } />
              }
            </button>
        )
    }
    
    renderLink = () => {
        const {
            extra_class,
            onClickButton,
            disabled,
            to,
            icon_src
        } = this.props;
        
        return(
            <Link
                to={to}
                css={disabled ? [main, link, extra_class, link_disabled] : [main, link, extra_class]}
                onClick={!disabled ? onClickButton : function() {}} 
            >    
              {icon_src &&
               <img src={icon_src} alt="" />
              }
            </Link>
        )
    }
    
    render() {
        const { to } = this.props;
        
        if(to) {
            return this.renderLink()
        } else {
            return this.renderButton()
        }
    }
}
export default DefaultIconButton

const main = css`
background-color: transparent;
color: black;
padding: 0;
font-size: 15px;
outline: none;
cursor: pointer;
font-weight: 400;

img {
   display: block;
}
`

const btn = css`
border: none;

:disabled {
background-color: ${theme.colors.light};
color: black;
cursor: default;

&:hover, &:focus, &:active {
background-color: ${theme.colors.light};

}
}
`

const link = css`
text-decoration: none;
}
`

const link_disabled = css`
background-color: ${theme.colors.light};
color: black;
cursor: default;

&:hover, &:focus, &:active {
background-color: ${theme.colors.light};
`

const icon = css`
height: 4vh;
`
